import client from "@/api/client.js";
import i18n from "@/plugins/i18n.js";
import store from "@/store";

export default {
    methods: {
        async getCustomerGroupListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: "getCustomerGroupListFromFilter", input: { filter: filter } };
            var response = await client().get(`${store.state.apiRouteRoot}CustomerGroup/Filtered`, { params: filter, signal: cancelationToken, meta: meta });
            return response?.data;
        },

        async getCustomerGroupById(customerGroupId) {
            var meta = { clientApiMethod: "getCustomerGroupById", input: { customerGroupId: customerGroupId } };
            var response = await client().get(`${store.state.apiRouteRoot}CustomerGroup/${customerGroupId}`, { meta: meta });
            return response?.data;
        },

        async createCustomerGroup(customerGroup, image) {
            let formData = new FormData();

            if (!image && customerGroup.newImage) { //workaround for limitation of no param control on integrated new dialog
                image = customerGroup.newImage;
            }

            if (image) {
                formData.append("ImageFile", image, image.name);
            }
            formData.append("CustomerGroup", JSON.stringify(customerGroup));
            var meta = {
                clientApiMethod: "createCustomerGroup",
                input: { customerGroup },
                successText: i18n.t("servicesystem.responses.created_object", {
                    okey: i18n.t("servicesystem.common_objects.customer.group")
                })
            };
            var response = await client().post(store.state.apiRouteRoot + "CustomerGroup/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                meta: meta
            });
            return response?.data;
        },

        async changeCustomerGroup(customerGroup, image) {
            let formData = new FormData();
            if (image) {
                formData.append("ImageFile", image, image.name);
            }
            formData.append("CustomerGroup", JSON.stringify(customerGroup));
            var meta = {
                clientApiMethod: "changeCustomerGroup",
                input: { customerGroup },
                successText: i18n.t("servicesystem.responses.changed_object", {
                    okey: i18n.t("servicesystem.common_objects.customer.group")
                })
            };
            var response = await client().patch(store.state.apiRouteRoot + "CustomerGroup/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            });
            return response?.data;
        },

        async removeCustomerGroup(customerGroupId) {
            var meta = {
                clientApiMethod: "removeCustomerGroup",
                input: { customerGroupId: customerGroupId },
                successText: i18n.t("servicesystem.responses.removed_object", {
                    okey: i18n.t("servicesystem.common_objects.customer.group")
                })
            };
            var response = await client().delete(`${store.state.apiRouteRoot}CustomerGroup/${customerGroupId}`, { meta: meta });
            return response?.data;
        }
    }
};
